export default class Stats {

    constructor() {
        this.localStorage = window.localStorageSupported ? window.localStorage : {};

        this.highestScore = Number(this.localStorage.wordWipeHighestScore);
        this.updateHighestScore(0);

        this.highestLevel = Number(this.localStorage.wordWipeHighestLevel);
        this.updateHighestLevel(1);

        this.bestWord = this.localStorage.wordWipeBestWord;
        this.bestWordScore = Number(this.localStorage.wordWipeBestWordScore);
        this.updateBestWord('', 0);

        this.linesCleared = Number(this.localStorage.wordWipeLinesCleared);

        if (!this.linesCleared) {
            this.linesCleared = 0
        }
    }

    updateHighestScore(newScore) {
        if (this.highestScore < newScore || !this.highestScore) {
            this.highestScore = newScore;
            this.localStorage.wordWipeHighestScore = newScore
        }
    }

    updateHighestLevel(newLevel) {
        if (this.highestScore < newLevel || !this.highestLevel) {
            this.highestLevel = newLevel;
            this.localStorage.wordWipeHighestLevel = newLevel
        }
    }

    updateBestWord(word, score) {
        if (this.bestWordScore < score || !this.bestWordScore) {
            this.bestWordScore = score;
            this.bestWord = word;
            this.localStorage.wordWipeBestWord = word;
            this.localStorage.wordWipeBestWordScore = score;

            _gameGATracker('send', 'event', 'Best Word', word, score)
        }
    }

    onLineCleared() {
        this.linesCleared += 1;
        this.localStorage.wordWipeLinesCleared = this.linesCleared
    }

}

window.STATS = new Stats();
